<template>
  <div class="container px-6 is-flex is-justify-content-center is-align-items-center" style="height: 100%;">
    <div class="box bg-box" style="min-width: 380px; border-radius: 30px; padding: 30px 40px;">
      <div class="has-text-centered mb-4">
        <img
            src="@/assets/logo.png"
            alt="Logo"
            style="width: 100px;"
            class="mb-1"
            @click="onFullScreenMode"
        />
        <h2 class="subtitle has-text-weight-bold" style="color: #515e7b !important; margin-bottom: 0;">ダークティー <br> Daku
          Cha</h2>
        <!--        <p style="color: #515e7b !important;">Welcome</p>-->
      </div>
      <form>
        <div class="field">
          <label class="label is-size-7-tablet has-text-weight-normal pl-4 text-secondary">ຊື່ຜູ້ໃຊ້</label>
          <div class="control">
            <input
                name="username"
                ref="username"
                class="input has-text-centered"
                type="text"
                placeholder="ຊື່ຜູ້ໃຊ້"
                v-model="username"
            />
          </div>
        </div>
        <div class="field mt-4">
          <label class="label is-size-7-tablet has-text-weight-normal pl-4 text-secondary">ລະຫັດຜ່ານ</label>
          <div class="control">
            <input
                class="input has-text-centered"
                type="password"
                placeholder="ລະຫັດຜ່ານ"
                v-model="password"
                @keyup.enter="login()"
            />
          </div>
        </div>
        <button class="button is-primary mt-5 btn" type="button" @click="login()"
                style="display: block; width: 100%;">
          ເຂົ້າລະບົບ
        </button>
        <div class="has-text-right mt-4">
          <a
              href="https://dakuadmin.akat.la/"
              target="_blank"
              class="text-secondary"
          >Go to Admin Portal</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import sha1 from "js-sha1";
import http from "../http";
import {sync} from "vuex-pathify";

export default {
  name: "login",
  data() {
    return {
      salt: "jkhkjh%$&%$&*^*(JKYGKJ",
      username: null,
      password: null,
      isFullScreenMode: false
    };
  },
  computed: {
    user: sync("user"),
  },
  mounted() {
    if (this.user) {
      this.$router.replace({path: "/main"});
    }
    this.$refs.username.focus();
  },
  methods: {
    login() {
      if (!this.username || !this.password) {
        this.$swal("ກະລຸນາປ້ອນ ຊື່ຜູ້ໃຊ້ ແລະ ລະຫັດຜ່ານ", "", "warning");
        return;
      }
      http
          .post("login", {
            username: this.username,
            password: sha1(this.password + this.salt),
          })
          .then((res) => {
            this.$store.set("user", res.user);
            this.$store.set("branch", res.branch);
            this.$store.set("table", res.table);
            this.$store.set("token", res.token);
            this.$store.set("itemcategories", res.itemcategories);
            this.$store.set("items", res.items);
            this.$store.set("customerTypes", res.customerTypes);
            http.get("customers").then((customers) => {
              this.$store.set("customers", customers);
            });
            http.get("options").then((options) => {
              this.$store.set("options", options);
            });
            http.get("paymenttypes").then((res) => {
              this.$store.set("paymenttypes", res);
              this.paymenttypes = res;
              if (this.paymenttypes && this.paymenttypes.length > 0) {
                this.selectedpaymentid = 0;
                this.paymenttype = this.paymenttypes[this.selectedpaymentid];
              }
            });
            this.$router.replace({path: "/main"});
          })
          .catch(() => {
            this.$swal("ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານ ບໍ່ຖືກຕ້ອງ", "", "error");
          });
    },
    onFullScreenMode() {
      if (!this.isFullScreenMode) {
        const element = document.querySelector("body");
        element.requestFullscreen()
        this.isFullScreenMode = true
      } else {
        document.exitFullscreen()
        this.isFullScreenMode = false
      }
    }
  },
};
</script>
<style scoped>
</style>